import { FC, useEffect } from 'react';
import Button from 'v3/common/components/Button';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import UserInput from 'v3/common/components/UserInput';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';

const Kbs: FC<BrokerSpecificComponentsProps> = ({ userConfigs, brokerSpecificHandles }) => {
  const { validateClientId, updatePartialConfigs, changeApiKey, reDirectPage, isMobile } =
    brokerSpecificHandles;
  const {
    clientId,
    isLoading,
    isClientValidated,
    shouldShowApiKey,
    shouldShowSecretKey,
    apiKey,
    secretKey,
    brokerVariant,
    isValidForm,
    selectedBrokerConfig,
  } = userConfigs;

  const broker = selectedBrokerConfig?.id;

  // Temp fix to set broker variant
  useEffect(() => {
    updatePartialConfigs({
      brokerVariant: 'retail',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // TODO this is temp fix, Yet to be declared somewhere.
  const renderUserType = () => {
    return (
      <div className="user-input__container">
        <label htmlFor="userType">UserType</label>
        <select
          name="userType"
          id="userType"
          value={brokerVariant}
          onChange={(e) => updatePartialConfigs({ brokerVariant: e.target.value })}
          disabled={isClientValidated}
        >
          <option value="retail">KBS India</option>
          <option value="pro">KBS PRO</option>
        </select>
      </div>
    );
  };

  return (
    <form
      id={`${broker}-form`}
      onSubmit={(e) => {
        e.preventDefault();
        return isClientValidated
          ? reDirectPage({ user_type: brokerVariant }, false)
          : validateClientId({ broker: `kbs_${brokerVariant}` });
      }}
    >
      <UserInput
        autoFocus={!isMobile}
        labelValue="Client Id"
        id={`${broker}-client-id`}
        value={clientId}
        isDisabled={isClientValidated}
        placeholder="Enter Client Id"
        onHandleChange={(value: string) => updatePartialConfigs({ clientId: value })}
      />

      {clientId && !isClientValidated && (
        <button type="button" onClick={() => changeApiKey()}>
          <i className="fa-regular fa-gear fa-spin" />
          Change api?
        </button>
      )}

      {renderUserType()}

      {shouldShowApiKey && (
        <UserInput
          labelValue="APP Key"
          id={`${broker}-app-key`}
          value={apiKey}
          placeholder="Enter APP Key"
          onHandleChange={(value: string) => updatePartialConfigs({ apiKey: value })}
        />
      )}

      {shouldShowSecretKey && (
        <UserInput
          labelValue="Secret Key"
          id={`${broker}-secret-key`}
          value={secretKey}
          placeholder="Enter API Secret"
          onHandleChange={(value: string) => updatePartialConfigs({ secretKey: value })}
        />
      )}

      {isClientValidated && (
        <div className="alert alert-warning">
          Please contact KBS support to get your APP Key and Secret Key
        </div>
      )}

      {!isValidForm && <div className="invalid-feedback d-block">Please provide the details</div>}

      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button type="submit" form={`${broker}-form`} isLoading={isLoading}>
          {isClientValidated ? 'Login' : 'Validate'}
        </Button>
      </PortalToTarget>
    </form>
  );
};

export default Kbs;
